"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    ComboboxContext: ()=>ComboboxContext,
    ComboboxProvider: ()=>ComboboxProvider
});
const _reactContextSelector = require("@fluentui/react-context-selector");
const ComboboxContext = /*#__PURE__*/ (0, _reactContextSelector.createContext)({
    activeOption: undefined,
    appearance: 'outline',
    focusVisible: false,
    open: false,
    registerOption () {
        return ()=>undefined;
    },
    selectedOptions: [],
    selectOption () {
    // noop
    },
    setActiveOption () {
    // noop
    },
    setOpen () {
    // noop
    },
    size: 'medium'
});
const ComboboxProvider = ComboboxContext.Provider; //# sourceMappingURL=ComboboxContext.js.map

//# sourceMappingURL=ComboboxContext.js.map